import { useState } from "react";
import { Button } from "reactstrap";
import { Reminders, SetReminders } from "../../../../Constants/Constants";
import CommonHeading from "../Common/CommonHeading";
import ReminderList from "./ReminderList";
import ReminderModal from "./ReminderModal";

const Reminder = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  return (
    <div className="reminder-main">
      <CommonHeading title={Reminders} sunTitle={SetReminders} />
      <div className="reminder-content tab-card">
        <i className="ti-alarm-clock" />
        <p>Never forget important tasks. Set personal and group reminders.</p>
        <Button color="primary" size="sm" className="setreminder button-effect" onClick={toggle}>set reminder</Button>
      </div>
      <ReminderModal modal={modal} toggle={toggle}/>
      <ReminderList />
    </div>
  );
};

export default Reminder;
